import type { CSSProperties } from 'react';

import { isDefined } from '@enterprise/core';

import type { LoadingProps } from './types/loading.props';

/**
 * Renders a ring-shaped loading spinner.
 *
 * @internal
 * @param size - The multiplier for the loader size. If greater than 1, applies a corresponding CSS class.
 * @returns A JSX element representing the loading ring.
 */
export const Ring = ({ size }: LoadingProps) => {
  return (
    <div
      className="loader-ring"
      style={{ '--multiplier': isDefined(size) ? size : undefined } as CSSProperties}>
      <div />
      <div />
      <div />
    </div>
  );
};
